<div class="configurationContainer">
    <div class="header hdr">
      <h5> <span class="animateH5">Configuration</span></h5>
    </div>
    <div class="container-fluid align-items-start configContents">
      <div class="row">
        <div class="col-md-2 offset-md-1 configTab">
            <ul class="nav flex-column nav-pills nav-justified" id="v-pills-tab" role="tablist" aria-orientation="vertical">
                <li class="nav-item jerk-tab-class" [ngClass]="{'tri':tabTriangle==='topic'}" (click)="showTriangle('topic')">
                  <a class="nav-link active tabBtn" id="v-pills-home-tab" data-bs-toggle="tab" data-bs-target="#v-pills-home"
                    type="button" role="tab" aria-controls="v-pills-home" aria-selected="true">Topic & Keywords</a>
                </li>
                <li class="nav-item jerk-tab-class" [ngClass]="{'tri':tabTriangle==='survey'}"
                  (click)="showTriangle('survey')" *ngIf="userDetails?.email === 'anandan.chinnalagu@matrixcos.com' ">
                  <a class="nav-link" id="v-pills-profile-tab" data-bs-toggle="tab" data-bs-target="#v-pills-profile"
                    type="button" role="tab" aria-controls="v-pills-profile" aria-selected="false"
                    (click)="getSurveyData()">Survey</a>
                </li>
                <li class="nav-item jerk-tab-class" (click)="getNotificationData()"
                  [ngClass]="{'tri':tabTriangle==='notification'}" (click)="showTriangle('notification')">
                  <a class="nav-link" id="v-pills-messages-tab" data-bs-toggle="tab" data-bs-target="#v-pills-messages"
                    type="button" role="tab" aria-controls="v-pills-messages" aria-selected="false">Notification</a>
                </li>
                <!-- <li class="nav-item jerk-tab-class" [ngClass]="{'tri':tabTriangle==='stopword'}"
                  (click)="showTriangle('stopword')">
                  <a class="nav-link" id="v-pills-settings-tab" data-bs-toggle="tab" data-bs-target="#v-pills-settings"
                    type="button" role="tab" aria-controls="v-pills-settings" aria-selected="false"
                    (click)="getStopWordData('a', 'tab')">Stop Words</a>
                </li> -->
              </ul>
        </div>
        <div class="col-md-8 tableTab">
            <div class="tab-content" id="v-pills-tabContent">
              <div class="tab-pane fade show active" id="v-pills-home" role="tabpanel" aria-labelledby="v-pills-home-tab">
                <div class="card">
                  <div class="card-body">
                    <div class="tblHead d-flex border-bottom">
                      <div class="firstPart">
                        <h4>Topic & Keywords
                          <i *ngIf="spinner" class="fa fa-spinner fa-pulse fa-1x fa-fw"></i>
                          <span class="sr-only">Loading...</span>
                        </h4>
                      </div>
                      <div class="secondPart">
                        <i class="fa-solid fa-square-plus plusIcon" (click)="showButtonFun()" data-bs-toggle="modal"
                          data-bs-target="#topicDetails" tooltip="Create New Topic" [options]="myOptions"></i>
                      </div>
                    </div>
                    <div class="table-responsive">
                      <table class="table table-hover">
                        <thead class="tblHeadings">
                          <tr>
                            <th>topic name</th>
                            <th>keywords</th>
                            <th>alert keywords</th>
                            <th>sensitive keywords</th>
                            <th>hide keywords</th>
                            <th>delete keywords</th>
                            <th>email</th>
                            <th>option</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr class="text-center" *ngIf="topicKeywordData.length === 0 && !spinner">
                            <td colspan="10">
                              <p class="noRecord">No Records Found</p>
                          </tr>
                          <tr class="topicKeywordTable" [ngClass]="{'selectedClass':i===tableTrVar}" (click)="tableBack(i)"
                            *ngFor="let result of topicKeywordData; index as i;">
                            <td class="tdTopic">{{result.topic}} <b *ngIf="!result.topic">-</b></td>
                            <td class="tdKeywords emailCol">
                              <!-- <span appReadMore [toggle]="true" [limit]="150" *ngIf="result.keywords">{{result.keywords}} </span> -->
                               <p appReadMoreExpand [popup]="true" [closeIcon]="'fa-solid fa-xmark'" [toggle]="true" [limit]="20" *ngIf="result.keywords">{{result.keywords}}</p>
                              <b *ngIf="!result.keywords">-</b></td>
                            <td class="tdOtherKeyword">
                              <span appReadMore [toggle]="true" [limit]="150" *ngIf="result.alert_words">{{result.alert_words}}</span> <b *ngIf="!result.alert_words">-</b></td>
                            <td class="tdOtherKeyword">
                              <span appReadMore [toggle]="true" [limit]="150" *ngIf="result.sensitive_words">{{result.sensitive_words}}</span> <b *ngIf="!result.sensitive_words">-</b>
                            </td>
                            <td class="tdOtherKeyword">
                              <span appReadMore [toggle]="true" [limit]="150" *ngIf="result.hide_words">{{result.hide_words}}</span> <b *ngIf="!result.hide_words">-</b></td>
                            <td class="tdOtherKeyword">
                              <span appReadMore [toggle]="true" [limit]="150" *ngIf="result.delete_words">{{result.delete_words}}</span> <b *ngIf="!result.delete_words">-</b></td>
                            <td class="tdEmail">
                              <span appReadMore [toggle]="true" [limit]="150" *ngIf="result.mail_copies">{{result.mail_copies}}</span> <b *ngIf="!result.mail_copies">-</b></td>
                            <td class="tdOtherKeyword">
                              <i class="fa-regular fa-pen-to-square configIcon" (click)="getTopicsData(i)"
                                data-bs-toggle="modal" data-bs-target="#topicDetails" tooltip="Edit"
                                [options]="myOptions"></i>
                              <i class="fa-regular fa-trash-can configIcon" *ngIf="result.topic_ref_count === 0"
                                data-bs-toggle="modal" data-bs-target="#exampleModal"  
                                tooltip="Delete" [options]="myOptions"></i>
                              <!-- <span tooltip="This Topic was linked with file/document" [options]="myOptions">
                                <i class="fa-regular fa-trash-can configIcon" *ngIf="result.topic_ref_count > 0"
                                  data-bs-toggle="modal" data-bs-target="#exampleModal" (click)="justShowIndex(i)"
                                  [attr.disabled]="true"></i>
                              </span> -->
                              <span tooltip="This Topic was linked with file/document" [options]="myOptions">
                                <i class="fa-regular fa-trash-can configIcon" *ngIf="result.topic_ref_count > 0"
                                   [attr.disabled]="true"></i>
                              </span>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
              <!-- Survey Tab -->
              <div class="tab-pane fade" id="v-pills-profile" role="tabpanel" aria-labelledby="v-pills-profile-tab">
                <div class="card surveyCardClass">
                  <i *ngIf="spinner" class="fa fa-spinner fa-pulse fa-1x fa-fw"></i>
                  <span class="sr-only">Loading...</span>
                  <div class="card-body">
                    <div class="tblHead d-flex border-bottom">
                      <div class="firstPart">
                        <h4>Survey Configuration</h4>
                      </div>
                      <div class="secondPart">
                        <i class="fa-solid fa-square-plus plusIcon" data-bs-toggle="modal" data-bs-target="#newSurveyModal"
                          tooltip="Create New Survey" [options]="myOptions"></i>
                      </div>
                    </div>
                    <div class="table-responsive">
                      <table class="table">
                        <thead class="tblHeadings">
                          <tr>
                            <th class="survey-tbl-first-th">survey</th>
                            <th>option</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr *ngFor=" let result of survyTableData; index as i">
                            <td>{{result.survey_name}}</td>
                            <td class="tdOtherKeyword">
                              <i class="fa-regular fa-pen-to-square configIcon" tooltip="Edit" [options]="myOptions"
                                (click)="sendSurveyIndex(i)" data-bs-toggle="modal" data-bs-target="#newSurveyModal"></i>
                              <i class="fa-regular fa-trash-can configIcon" tooltip="Delete" [options]="myOptions"></i>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
              <!-- Notification Tab -->
              <div class="tab-pane fade" id="v-pills-messages" role="tabpanel" aria-labelledby="v-pills-messages-tab">
                <div class="card notificationCard">
                  <div class="card-body">
                    <form [formGroup]="notificationForm">
                      <div class="table-responsive">
                        <table class="table notification-table">
                          <thead class="tblHeadings">
                            <tr>
                              <th class="survey-tbl-first-th">general notification</th>
                              <th>in app</th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr>
                              <td class="border-end">Enable Alert Email notification</td>
                              <td>
                                <div class="form-check form-switch">
                                  <input class="form-check-input" formControlName="alert" type="checkbox" role="switch"
                                    id="alert">
                                </div>
                              </td>
                            </tr>
                            <tr>
                              <td class="border-end">Enable Completed Email notification</td>
                              <td>
                                <div class="form-check form-switch">
                                  <input class="form-check-input" formControlName="complete" type="checkbox" role="switch"
                                    id="complete">
                                </div>
                              </td>
                            </tr>
                            <tr>
                              <td class="border-end">Enable Failure Email notification</td>
                              <td>
                                <div class="form-check form-switch">
                                  <input class="form-check-input" formControlName="failure" type="checkbox" role="switch"
                                    id="failure">
                                </div>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                      <div class="card-footer">
                        <button class="btn btn-primary updateBtn" (click)=" updateNotification()"
                          [disabled]="!notificationForm.dirty">Update</button>
                      </div>
                    </form>
                  </div>
                </div>
    
              </div>
              <!-- Stop Words Tab -->
              <div class="tab-pane fade" id="v-pills-settings" role="tabpanel" aria-labelledby="v-pills-settings-tab">
                <div class="card stop-word-card">
                  <div class="card-body">
                    <div class="tblHead border-bottom">
                      <div class="row">
                        <div class="col-md-6">
                          <div class="firstPart">
                            <h4>Stop Word List</h4>
                          </div>
                        </div>
                        <div class="col-md-6">
                          <div class="secondPart">
                            <input type="text" class="form-control" placeholder="Start with - Search"
                              (ngModelChange)="this.stopWordSearchUpdate.next($event)" [(ngModel)]="stopWordSearch">
                            <i class="fa-solid fa-square-plus plusIcon" (click)="stopWordModalOpen('create')"
                              data-bs-toggle="modal" data-bs-target="#stopWordModal" tooltip="Create Stop Word"
                              [options]="myOptions"></i>
                          </div>
                        </div>
                      </div>
    
                    </div>
                    <div class="table-responsive">
                      <table class="table">
                        <thead class="tblHeadings">
                          <tr>
                            <th colspan="2">
                              <ul class="list-group list-group-horizontal">
                                <a class="list-group-item" (click)="stopWordTabFun('a')"
                                  (click)="getStopWordData('a', 'tab')" [ngClass]="{'active':stopWordTab === 'a'}">A</a>
                                <a class="list-group-item" (click)="stopWordTabFun('b')"
                                  (click)="getStopWordData('b', 'tab')" [ngClass]="{'active':stopWordTab === 'b'}">B</a>
                                <a class="list-group-item" (click)="stopWordTabFun('c')"
                                  (click)="getStopWordData('c', 'tab')" [ngClass]="{'active':stopWordTab === 'c'}">C</a>
                                <a class="list-group-item" (click)="stopWordTabFun('d')"
                                  (click)="getStopWordData('d', 'tab')" [ngClass]="{'active':stopWordTab === 'd'}">D</a>
                                <a class="list-group-item" (click)="stopWordTabFun('e')"
                                  (click)="getStopWordData('e', 'tab')" [ngClass]="{'active':stopWordTab === 'e'}">E</a>
                                <a class="list-group-item" (click)="stopWordTabFun('f')"
                                  (click)="getStopWordData('f', 'tab')" [ngClass]="{'active':stopWordTab === 'f'}">F</a>
                                <a class="list-group-item" (click)="stopWordTabFun('g')"
                                  (click)="getStopWordData('g', 'tab')" [ngClass]="{'active':stopWordTab === 'g'}">G</a>
                                <a class="list-group-item" (click)="stopWordTabFun('h')"
                                  (click)="getStopWordData('h', 'tab')" [ngClass]="{'active':stopWordTab === 'h'}">H</a>
                                <a class="list-group-item" (click)="stopWordTabFun('i')"
                                  (click)="getStopWordData('i', 'tab')" [ngClass]="{'active':stopWordTab === 'i'}">I</a>
                                <a class="list-group-item" (click)="stopWordTabFun('j')"
                                  (click)="getStopWordData('j', 'tab')" [ngClass]="{'active':stopWordTab === 'j'}">J</a>
                                <a class="list-group-item" (click)="stopWordTabFun('k')"
                                  (click)="getStopWordData('k', 'tab')" [ngClass]="{'active':stopWordTab === 'k'}">K</a>
                                <a class="list-group-item" (click)="stopWordTabFun('l')"
                                  (click)="getStopWordData('l', 'tab')" [ngClass]="{'active':stopWordTab === 'l'}">L</a>
                                <a class="list-group-item" (click)="stopWordTabFun('m')"
                                  (click)="getStopWordData('m', 'tab')" [ngClass]="{'active':stopWordTab === 'm'}">M</a>
                                <a class="list-group-item" (click)="stopWordTabFun('n')"
                                  (click)="getStopWordData('n', 'tab')" [ngClass]="{'active':stopWordTab === 'n'}">N</a>
                                <a class="list-group-item" (click)="stopWordTabFun('o')"
                                  (click)="getStopWordData('o', 'tab')" [ngClass]="{'active':stopWordTab === 'o'}">O</a>
                                <a class="list-group-item" (click)="stopWordTabFun('p')"
                                  (click)="getStopWordData('p', 'tab')" [ngClass]="{'active':stopWordTab === 'p'}">P</a>
                                <a class="list-group-item" (click)="stopWordTabFun('q')"
                                  (click)="getStopWordData('q', 'tab')" [ngClass]="{'active':stopWordTab === 'q'}">Q</a>
                                <a class="list-group-item" (click)="stopWordTabFun('r')"
                                  (click)="getStopWordData('r', 'tab')" [ngClass]="{'active':stopWordTab === 'r'}">R</a>
                                <a class="list-group-item" (click)="stopWordTabFun('s')"
                                  (click)="getStopWordData('s', 'tab')" [ngClass]="{'active':stopWordTab === 's'}">S</a>
                                <a class="list-group-item" (click)="stopWordTabFun('t')"
                                  (click)="getStopWordData('t', 'tab')" [ngClass]="{'active':stopWordTab === 't'}">T</a>
                                <a class="list-group-item" (click)="stopWordTabFun('u')"
                                  (click)="getStopWordData('u', 'tab')" [ngClass]="{'active':stopWordTab === 'u'}">U</a>
                                <a class="list-group-item" (click)="stopWordTabFun('v')"
                                  (click)="getStopWordData('v', 'tab')" [ngClass]="{'active':stopWordTab === 'v'}">V</a>
                                <a class="list-group-item" (click)="stopWordTabFun('w')"
                                  (click)="getStopWordData('w', 'tab')" [ngClass]="{'active':stopWordTab === 'w'}">W</a>
                                <a class="list-group-item" (click)="stopWordTabFun('x')"
                                  (click)="getStopWordData('x', 'tab')" [ngClass]="{'active':stopWordTab === 'x'}">X</a>
                                <a class="list-group-item" (click)="stopWordTabFun('y')"
                                  (click)="getStopWordData('y', 'tab')" [ngClass]="{'active':stopWordTab === 'y'}">Y</a>
                                <a class="list-group-item" (click)="stopWordTabFun('z')"
                                  (click)="getStopWordData('z', 'tab')" [ngClass]="{'active':stopWordTab === 'z'}">Z</a>
                              </ul>
                            </th>
                          </tr>
                          <tr>
                            <th class="survey-tbl-first-th">stop word <i *ngIf="spinner"
                                class="fa fa-spinner fa-pulse fa-3x fa-fw"></i>
                              <span class="sr-only">Loading...</span>
                            </th>
                            <th>option</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr *ngFor="let result of stopWordTblData | search: searchText; index as i">
                            <td>{{result}}</td>
                            <td class="tdOtherKeyword">
                              <i class="fa-regular fa-pen-to-square configIcon" (click)="stopWordModalOpen('edit')"
                                (click)="sendStopWordIndex(i)" tooltip="Edit" [options]="myOptions" data-bs-toggle="modal"
                                data-bs-target="#stopWordModal"></i>
                              <i class="fa-regular fa-trash-can configIcon" data-bs-toggle="modal"
                                data-bs-target="#stopWordDeleteModal" (click)="sendStopWordIndex(i)" tooltip="Delete"
                                [options]="myOptions"></i>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
      </div>



        <!-- Delete Modal Window -->
        <div class="modal fade deleteModal" id="exampleModal" tabindex="-1" aria-labelledby="exampleModalLabel"  aria-hidden="true">
            <div class="modal-dialog">
                    <div class="modal-content">
                        <div class="modal-header">
                        <h4 class="modal-title" id="exampleModalLabel">Delete Topic</h4>
                        <i class="fa-solid fa-xmark exitIcon" data-bs-dismiss="modal" aria-label="Close"></i>
                        </div>
                        <div class="modal-body">
                        Are you sure you want to delete?
                        </div>
                        <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">No</button>
                        <button type="button" class="btn btn-danger" (click)="deleteTopic(deleteIndex)"
                            data-bs-dismiss="modal">Yes</button>
                        </div>
                    </div>
            </div>
        </div>

         <!--topics form modal window -->
        <div class="modal fade topicFormModal" data-bs-backdrop="static" data-bs-keyboard="false" id="topicDetails"
        #topicModal>
        <div class="modal-dialog modal-dialog-scrollable modal-lg" [ngClass]="{'full-screen':metricFullscreen}">
        <div class="modal-content">
            <div class="modal-header">
            <h4 class="modal-title">Configurations</h4>
            <span>
                <i class="fa metricFullscreen" [ngClass]="{'fa-down-left-and-up-right-to-center':metricFullscreen,'fa-up-right-and-down-left-from-center':!metricFullscreen}"  (click)="metricFullscreen = !metricFullscreen"></i>&nbsp;&nbsp;
                <i class="fa-solid fa-xmark exitIcon" #closebutton data-bs-dismiss="modal" aria-label="Close"
                (click)="exitIconReset()"></i>
            </span>
            
            </div>
            <div><i *ngIf="spinner"
            class="fa fa-spinner fa-pulse fa-3x fa-fw"></i>
            <span class="sr-only">Loading...</span>
            </div>
            <div class="modal-body" *ngIf="!spinner">
            <div class="col-md-8 offset-md-2">
                <form class="topicForm" [formGroup]="topicForm" autocomplete="off">
                <div class="row">
                    <div class="col-md-6">
                    <div class="form-check form-check-inline">
                        <input class="form-check-input" type="radio" name="call_type" formControlName="call_type"
                        value="inbound" id="inlineRadio1" checked>
                        <label class="form-check-label" for="inlineRadio1">
                        Inbound
                        </label>
                    </div>
                    <div class="form-check form-check-inline">
                        <input class="form-check-input" type="radio" name="call_type" formControlName="call_type"
                        value="outbound" id="inlineRadio2">
                        <label class="form-check-label" for="inlineRadio2">
                        Outbound
                        </label>
                    </div>
                    </div>
                    <div class="col-md-6">
                    <div class="expand-btn-class">
                        <button class="btn btn-primary updateBtn" *ngIf="(!expandButtonShow)"
                        (click)="expandTopicsAllTabs('expand')">
                        Expand All
                        </button>
                        <button class="btn btn-primary updateBtn" *ngIf="(expandButtonShow)"
                        (click)="expandTopicsAllTabs('collapse')">
                        Collapse All
                        </button>
                    </div>
                    </div>
                </div>
                <div class="form-group">
                    <label for="topic" class="form-label mandatoryLabel">Topic Name
                    <i class="fa-solid fa-asterisk mandatoryIcon"></i></label>
                    <input type="text" class="form-control" formControlName="topic" id="topic" name="topic"
                    placeholder="Enter Your Topic Name" autocomplete="off" NoWhitespace>
                    <span class="text-danger"
                    *ngIf="topicForm.controls['topic'].dirty && topicForm.hasError('required','topic') && topicForm.controls['topic'].hasError('pattern')">Topic Name is
                    required.
                    </span>
                    <span class="text-danger"
                    *ngIf="topicForm.controls['topic'].value !=''  && topicForm.controls['topic'].hasError('pattern')">Enter valid Topic Name
                    </span>
                </div>
                <div class="form-group">
                    <div class="accordion" id="accordionPanelsStayOpenExample">
                    <div class="accordion-item accordionClass">
                        <h2 class="accordion-header" id="panelsStayOpen-headingOne">
                        <button class="accordion-button collapsed" #accordionBtn1 (click)="toggleCollapsed('1')"
                            type="button" data-bs-toggle="collapse" data-bs-target="#panelsStayOpen-collapseOne"
                            aria-expanded="false" aria-controls="panelsStayOpen-collapseOne">
                            <!-- [ngClass]="{'available': updateBoolean && !topicForm.controls['keywords'].value?.length && !topicForm.controls['alert_words'].value?.length && !topicForm.controls['sensitive_words'].value?.length && !topicForm.controls['hide_words'].value?.length && !topicForm.controls['delete_words'].value?.length}" -->
                            Keywords / Phrase Configuration <span class="no-data-accordion"
                            *ngIf="updateBoolean && !topicForm.controls['keywords'].value?.length && !topicForm.controls['alert_words'].value?.length && !topicForm.controls['sensitive_words'].value?.length && !topicForm.controls['hide_words'].value?.length && !topicForm.controls['delete_words'].value?.length">
                            - No Data</span>
                        </button>
                        </h2>
                        <div id="panelsStayOpen-collapseOne" class="accordion-collapse collapse"
                        aria-labelledby="panelsStayOpen-headingOne">
                        <div class="accordion-body">
                            <div class="form-group">
                            <label class="form-label">Keywords / Phrase</label>
                            <tag-input class="form-control tagInput-form-control" placeholder="Keyword"
                                secondaryPlaceholder="Enter Your Keyword" [trimTags]="true" [addOnBlur]="true"
                                [clearOnBlur]="true" [modelAsStrings]="true" theme="minimal" formControlName="keywords"
                                id="keywords" name="keywords" autocomplete="off" [addOnPaste]="true"
                                [pasteSplitPattern]="splitPattern" (onAdd)="onKeywordsAdded($event,'keywords')"></tag-input>
                            <span class="modalNote">Note: To add multiple keywords, please Press Enter Key after
                                typing
                                each keyword</span>
                            </div>
                            <div class="form-group">
                            <label class="form-label">Alert Keywords</label>
                            <tag-input class="form-control tagInput-form-control" placeholder="Keyword"
                                secondaryPlaceholder="Enter Your Alert Keyword" [addOnBlur]="true" [clearOnBlur]="true"
                                [modelAsStrings]="true" theme="minimal" formControlName="alert_words" id="alert_words"
                                name="alert_words" autocomplete="off" [addOnPaste]="true"
                                [pasteSplitPattern]="splitPattern" (onAdd)="onKeywordsAdded($event,'alert_words')"></tag-input>
                            <span class="modalNote">Note: To add multiple keywords, please Press Enter Key after
                                typing
                                each keyword</span>
                            </div>
                            <div class="form-group">
                            <label class="form-label">Sensitive Keywords</label>
                            <tag-input class="form-control tagInput-form-control" placeholder="Keyword"
                                secondaryPlaceholder="Enter Your Sensitive Keyword" [addOnBlur]="true"
                                [clearOnBlur]="true" [modelAsStrings]="true" theme="minimal"
                                formControlName="sensitive_words" id="sensitive_words" name="sensitive_words"
                                autocomplete="off" [addOnPaste]="true" [pasteSplitPattern]="splitPattern" (onAdd)="onKeywordsAdded($event,'sensitive_words')"></tag-input>
                            <span class="modalNote">Note: To add multiple keywords, please Press Enter Key after
                                typing
                                each keyword</span>
                            </div>
                            <div class="form-group">
                            <label class="form-label">Hide Keywords</label>
                            <tag-input class="form-control tagInput-form-control" placeholder="Keyword"
                                secondaryPlaceholder="Enter Your Hide Keyword" [addOnBlur]="true" [clearOnBlur]="true"
                                [modelAsStrings]="true" theme="minimal" formControlName="hide_words" id="hide_words"
                                name="hide_words" autocomplete="off" [addOnPaste]="true"
                                [pasteSplitPattern]="splitPattern" (onAdd)="onKeywordsAdded($event,'hide_words')"></tag-input>
                            <span class="modalNote">Note: To add multiple keywords, please Press Enter Key after
                                typing
                                each keyword</span>
                            </div>
                            <div class="form-group">
                            <label class="form-label">Delete Keywords</label>
                            <tag-input class="form-control tagInput-form-control" placeholder="Keyword"
                                secondaryPlaceholder="Enter Your Delete Keyword" [addOnBlur]="true" [clearOnBlur]="true"
                                [modelAsStrings]="true" theme="minimal" formControlName="delete_words" id="delete_words"
                                name="delete_words" autocomplete="off" [addOnPaste]="true"
                                [pasteSplitPattern]="splitPattern" (onAdd)="onKeywordsAdded($event,'delete_words')"></tag-input>
                            <span class="modalNote">Note: To add multiple keywords, please Press Enter Key after
                                typing
                                each keyword</span>
                            </div>
                        </div>
                        </div>
                    </div>
                    <div class="accordion-item accordionClass" style="display: none;">
                        <h2 class="accordion-header" id="panelsStayOpen-headingTwo">
                        <button class="accordion-button collapsed" type="button" #accordionBtn2
                            (click)="toggleCollapsed('2')" data-bs-toggle="collapse"
                            data-bs-target="#panelsStayOpen-collapseTwo" aria-expanded="false"
                            aria-controls="panelsStayOpen-collapseTwo">
                            <!-- [ngClass]="{'available': updateBoolean && !topicForm.controls['pause_fillers'].value?.length && !topicForm.controls['positive_fillers'].value?.length }" -->
                            Modulation Configuration <span class="no-data-accordion"
                            *ngIf=" updateBoolean && !topicForm.controls['pause_fillers'].value?.length && !topicForm.controls['positive_fillers'].value?.length">
                            - No Data</span>
                        </button>
                        </h2>
                        <div id="panelsStayOpen-collapseTwo" class="accordion-collapse collapse"
                        aria-labelledby="panelsStayOpen-headingTwo">
                        <div class="accordion-body">
                            <div class="form-group">
                            <label class="form-label">Negative Modulation</label>
                            <tag-input class="form-control tagInput-form-control" placeholder="Keyword"
                                secondaryPlaceholder="Enter Your Keyword" formControlName="pause_fillers"
                                id="pause_fillers" name="pause_fillers" autocomplete="off" [addOnBlur]="true"
                                [clearOnBlur]="true" [modelAsStrings]="true" theme="minimal" [addOnPaste]="true"
                                [pasteSplitPattern]="splitPattern"></tag-input>
                            <span class="modalNote">Note: To add multiple keywords, please Press Enter Key after
                                typing
                                each keyword</span>
                            </div>
                            <div class="form-group">
                            <label class="form-label">Positive Modulation</label>
                            <tag-input class="form-control tagInput-form-control" placeholder="Keyword"
                                secondaryPlaceholder="Enter Your Keyword" formControlName="positive_fillers"
                                id="positive_fillers" name="positive_fillers" autocomplete="off" [addOnBlur]="true"
                                [clearOnBlur]="true" [modelAsStrings]="true" theme="minimal" [addOnPaste]="true"
                                [pasteSplitPattern]="splitPattern"></tag-input>
                            <span class="modalNote">Note: To add multiple keywords, please Press Enter Key after
                                typing
                                each keyword</span>
                            </div>
                        </div>
                        </div>
                    </div>
                    <div class="accordion-item accordionClass">
                        <h2 class="accordion-header" id="panelsStayOpen-headingThree">
                        <button class="accordion-button collapsed" #accordionBtn3 (click)="toggleCollapsed('3')"
                            type="button" data-bs-toggle="collapse" data-bs-target="#panelsStayOpen-collapseThree"
                            aria-expanded="false" aria-controls="panelsStayOpen-collapseThree" id="acBtnCall">
                            <!-- [ngClass]="{'available': updateBoolean && call_category.length === 0}" -->
                            Call Category Configuration <span class="no-data-accordion"
                            *ngIf="updateBoolean && call_category.length === 0"> - No Data</span>
                            <span class="formArrayValidationClass">
                            <i *ngIf="call_category.length > 0  && call_category.valid" class="fa fa-check"
                                aria-hidden="true"></i>
                            <i *ngIf="call_category.length > 0 && call_category.invalid" class="fa fa-exclamation"
                                aria-hidden="true"></i>
                            </span>
                        </button>
                        </h2>
                        <div id="panelsStayOpen-collapseThree" class="accordion-collapse collapse"
                        aria-labelledby="panelsStayOpen-headingThree">
                        <div class="accordion-body">
                            <ng-container formArrayName="call_category">
                            <ng-container *ngFor="let lessonForm of call_category.controls; index as i">
                                <div class="card border" *ngIf="showCard && call_category.length > 0">
                                <div class="form-group" [formGroupName]="i">
                                    <div class="form-group">
                                    <label class="form-label mandatoryLabel">Category <i
                                        class="fa-solid fa-asterisk mandatoryIcon"></i></label>
                                    <input type="text" formControlName="category" class="form-control" id="category"
                                        name="category" placeholder="Enter Category Name" NoWhitespace>
                                  <span class="text-danger" *ngIf="call_category.controls[i].get('category')?.dirty && call_category.controls[i].get('category')?.hasError('pattern')">Enter valid category</span>
                                    </div>
                                    <div class="form-group">
                                    <label class="form-label mandatoryLabel">Keywords <i
                                        class="fa-solid fa-asterisk mandatoryIcon"></i></label>
                                    <tag-input class="form-control tagInput-form-control" placeholder="Keyword"
                                        secondaryPlaceholder="Enter Your Keyword" formControlName="keywords" id="keywords"
                                        name="keywords" autocomplete="off" [addOnBlur]="true" [clearOnBlur]="true"
                                        [modelAsStrings]="true" theme="minimal" [addOnPaste]="true"
                                        [pasteSplitPattern]="splitPattern" (onAdd)="onKeywordsAddedformArray($event,'call_category',i,'keywords')"></tag-input>
                                    </div>
                                    <div class="form-group callCategoryCheck">
                                    <div class="row">
                                        <div class="col-md-5">
                                        <label class="form-label mandatoryLabel">Color <i
                                            class="fa-solid fa-asterisk mandatoryIcon"></i></label>
                                        <select name="color" formControlName="color" id="color" class="form-select">
                                            <!-- <option value="" disabled selected>Choose color</option> -->
                                            <option value="#52b788">Green</option>
                                            <option value="#e5383b">Red</option>
                                            <option value="#fdc500">Yellow</option>
                                        </select>
                                        </div>
                                        <div class="col-md-2 offset-md-3">
                                        <div class="form-check form-switch" *ngIf="updateBoolean">
                                            <label class="form-check-label" for="active">Metric Active</label>
                                            <input class="form-check-input" type="checkbox" formControlName="active"
                                            name="active" id="active">
                                        </div>
                                        <button type="button" class="btn btn-danger callBtn"
                                            (click)="deletecall_category(i)" *ngIf="!updateBoolean">Remove</button>
                                        </div>
                                    </div>
                                    </div>
                                </div>
                                </div>
                            </ng-container>
                            </ng-container>
                            <div class="callBtn2 d-flex justify-content-end">
                            <button class="btn btn-primary updateBtn" type="button" (click)="addcall_category()">Add
                                More</button>
                            </div>
                        </div>
                        </div>
                    </div>
                    <div class="accordion-item accordionClass">
                        <h2 class="accordion-header" id="panelsStayOpen-headingFour">
                        <button class="accordion-button collapsed" #accordionBtn4 (click)="toggleCollapsed('4')"
                            type="button" data-bs-toggle="collapse" data-bs-target="#panelsStayOpen-collapseFour"
                            aria-expanded="false" aria-controls="panelsStayOpen-collapseFour">
                            <!-- [ngClass]="{'available': updateBoolean && metrics.length === 0}" -->
                            QA Parameter <span class="no-data-accordion"
                            *ngIf="updateBoolean && metrics.length === 0"> - No Data</span>
                            <span class="formArrayValidationClass">
                            <i *ngIf="metrics.length > 0 && metrics.valid" class="fa fa-check" aria-hidden="true"></i>
                            <i *ngIf="metrics.length > 0 && metrics.invalid" class="fa fa-exclamation"
                                aria-hidden="true"></i>
                            </span>
                        </button>
                        </h2>
                        <div id="panelsStayOpen-collapseFour" class="accordion-collapse collapse"
                        aria-labelledby="panelsStayOpen-headingFour">
                        <div class="accordion-body">
                            <ng-container formArrayName="metrics">
                            <ng-container *ngFor="let lessonForm of metrics.controls; index as i">
                                <div class="card border" *ngIf="showCard && metrics.length > 0">
                                <div class="form-group" [formGroupName]="i">
                                    <div class="form-group">
                                    <label class="form-label mandatoryLabel">Category <i
                                        class="fa-solid fa-asterisk mandatoryIcon"></i></label>
                                    <input type="text" formControlName="category" class="form-control" id="category"
                                        name="category" placeholder="Enter Category Name" NoWhitespace>
                                         <span class="text-danger" *ngIf="metrics.controls[i].get('category')?.dirty && metrics.controls[i].get('category')?.hasError('pattern')">Enter valid category</span>
                                    </div>
                                    <div class="form-group">
                                    <label class="form-label mandatoryLabel">Keywords <i
                                        class="fa-solid fa-asterisk mandatoryIcon"></i></label>
                                    <tag-input class="form-control tagInput-form-control" placeholder="Keyword"
                                        secondaryPlaceholder="Enter Your Keyword" formControlName="keywords" id="keywords"
                                        name="keywords" autocomplete="off" [addOnBlur]="true" [clearOnBlur]="true"
                                        [modelAsStrings]="true" theme="minimal" [addOnPaste]="true"
                                        [pasteSplitPattern]="splitPattern" (onAdd)="onKeywordsAddedformArray($event,'metrics',i,'keywords')"></tag-input>
                                    </div>
                                    <div class="form-group">
                                    <label class="form-label mandatoryLabel">Score <i
                                        class="fa-solid fa-asterisk mandatoryIcon"></i></label>
                                    <input type="number" onkeydown="return event.keyCode !== 69" formControlName="score"
                                        class="form-control scoreInput" id="score" name="score" placeholder="Enter Score">
                                    </div>
                                
                                    <div class="form-group metricsCheck">
                                    <ng-container>
                                    
                                    <div class="row border-top">
                                        <div class="col-md-4">
                                    
                                        <div class="form-check form-switch">
                                            <label class="form-check-label" for="flexSwitchCheckDefault">Score
                                            Weightage</label>
                                            
                                            <input class="form-check-input" type="checkbox" formControlName="weitage"
                                            name="weitage" id="weitage">
                                        </div>
                                        </div>
                                    <div class="col-md-4" *ngIf="updateBoolean">
                                        <div class="form-check form-switch">
                                            <label class="form-check-label" for="active">Metric Active</label>
                                            <input class="form-check-input" type="checkbox" formControlName="active"
                                            name="active" id="active" >
                                        </div>
                                        </div>
                                    <div class="col-md-4 d-flex align-items-center" *ngIf="!updateBoolean">
                                        <label class="form-label pull-left">Error Type</label>
                                        <select class="form-select pull-left ms-1" style="width: auto;" name="type_error" formControlName="type_error">
                                            <option value="fatal">Fatal</option>
                                            <option value="business-critical">Business Critical</option>
                                            <option value="customer-critical">Customer Critical</option>
                                            <option value="semi-critical">Semi Critical</option>
                                            <option value="compliance-critical">Compliance Critical</option>
                                            <option value="non-fatal">Non-Fatal</option>
                                            <option value="non-critical">Non-Critical</option>
                                            <option value="ding">Ding</option>
                                            <option value="na">NA</option>
                                        </select>
                                        </div>
                                        <div class="col-md-4 d-flex align-items-center" *ngIf="updateBoolean">
                                        <label class="form-label pull-left">Error Type</label>
                                        <select class="form-select pull-left ms-1" style="width: auto;" name="type_error" formControlName="type_error">
                                            <option value="fatal">Fatal</option>
                                            <option value="business-critical">Business Critical</option>
                                            <option value="customer-critical">Customer Critical</option>
                                            <option value="semi-critical">Semi Critical</option>
                                            <option value="compliance-critical">Compliance Critical</option>
                                            <option value="non-fatal">Non-Fatal</option>
                                            <option value="non-critical">Non-Critical</option>
                                            <option value="ding">Ding</option>
                                            <option value="na">NA</option>
                                        </select>
                                        </div>
                                        <div class="col-md-4" *ngIf="!updateBoolean">
                                        <div class="form-check form-switch">
                                            <label class="form-check-label" for="free_score">Auto Score</label>
                                            <input class="form-check-input" type="checkbox" id="free_score"
                                            name="free_score" formControlName="free_score">
                                        </div>
                                        </div>
                                        <div class="col-md-4" *ngIf="updateBoolean">
                                        <div class="form-check form-switch">  
                                            <label class="form-check-label" for="free_score">Auto Score</label>
                                            <input class="form-check-input" type="checkbox" id="free_score"
                                            formControlName="free_score" name="free_score">
                                        </div>
                                        </div>
                                    <div class="col-md-4" *ngIf="!updateBoolean">
                                        <div class="form-check form-switch">
                                            <label class="form-check-label" for="score_text_enable">Non-Score</label>
                                            <input class="form-check-input"  type="checkbox" id="score_text_enable"
                                            formControlName="score_text_enable" name="score_text_enable">
                                        </div>
                                        </div>
                                        <div class="col-md-4 " *ngIf="updateBoolean">
                                        <div class="form-check form-switch">
                                            <label class="form-check-label" for="score_text_enable">Non-Score</label>
                                            <input class="form-check-input"  type="checkbox"
                                            id="score_text_enable" formControlName="score_text_enable"
                                            name="score_text_enable">
                                        </div>
                                        </div>
                                        <div class="col-md-4" *ngIf="!updateBoolean">
                                        <div class="form-check form-switch">
                                            <label class="form-check-label" for="negative_question">Negative
                                            Parameter</label>
                                            <input class="form-check-input" type="checkbox" id="negative_question"
                                            formControlName="negative_question" name="negative_question">
                                        </div>
                                        </div>
                                        <div class="col-md-4 " *ngIf="updateBoolean">
                                        <div class="form-check form-switch">
                                            <label class="form-check-label" for="negative_question">Negative
                                            Parameter</label>
                                            <input class="form-check-input" value="false" type="checkbox"
                                            id="negative_question" formControlName="negative_question"
                                            name="negative_question">
                                        </div>
                                        </div>  
                                        <div class="col-md-4 offset-md-8" *ngIf="!updateBoolean">
                                        <button type="button" class="btn btn-danger callBtn"
                                            (click)="deletemetrics(i)">Remove</button>
                                        </div>
                                    </div>
                                    </ng-container>
                                    <!-- <ng-template #notdcbClient>
                                    <div class="row border-top">
                                        <div class="col-md-4">
                                        <div class="form-check form-switch">
                                            <label class="form-check-label" for="flexSwitchCheckDefault">Score
                                            Weightage</label>
                                            <input class="form-check-input" type="checkbox" formControlName="weitage"
                                            name="weitage" id="weitage">
                                        </div>
                                        </div>
                                        <div class="col-md-4 offset-md-2" *ngIf="updateBoolean">
                                        <div class="form-check form-switch">
                                            <label class="form-check-label" for="active">Metric Active</label>
                                            <input class="form-check-input" type="checkbox" formControlName="active"
                                            name="active" id="active">
                                        </div>
                                        </div>
                                    
                                        <div class="col-md-4 offset-md-2" *ngIf="!updateBoolean">
                                        <div class="form-check form-switch">
                                            <label class="form-check-label" for="free_score">Auto Score</label>
                                            <input class="form-check-input" type="checkbox" id="free_score"
                                            name="free_score" formControlName="free_score">
                                        </div>
                                        </div>
                                        <div class="col-md-4" *ngIf="updateBoolean">
                                        <div class="form-check form-switch">
                                            <label class="form-check-label" for="free_score">Auto Score</label>
                                            <input class="form-check-input" type="checkbox" id="free_score"
                                            formControlName="free_score" name="free_score">
                                        </div>
                                        </div>
                                        <div class="col-md-4" *ngIf="!updateBoolean">
                                        <div class="form-check form-switch">
                                            <label class="form-check-label" for="negative_question">Negative
                                            Parameter</label>
                                            <input class="form-check-input" type="checkbox" id="negative_question"
                                            formControlName="negative_question" name="negative_question">
                                        </div>
                                        </div>
                                        <div class="col-md-4 offset-md-2" *ngIf="updateBoolean">
                                        <div class="form-check form-switch">
                                            <label class="form-check-label" for="negative_question">Negative
                                            Parameter</label>
                                            <input class="form-check-input" value="false" type="checkbox"
                                            id="negative_question" formControlName="negative_question"
                                            name="negative_question">
                                        </div>
                                        </div>
                                        <div class="col-md-4 offset-md-4" *ngIf="!updateBoolean">
                                        <button type="button" class="btn btn-danger callBtn"
                                            (click)="deletemetrics(i)">Remove</button>
                                        </div>
                                    </div>
                                    </ng-template> -->
                                    </div>
                                </div>
                                </div>
                            </ng-container>
                            </ng-container>
                            <div class="callBtn2 d-flex justify-content-end">
                            <button class="btn btn-primary updateBtn" type="button" (click)="addmetrics()">Add
                                More</button>
                            </div>
                        </div>
                        </div>
                    </div>
                    </div>
                </div>
                <div class="form-group">
                    <label for="mail_copies" class="form-label">To Email</label>
                    <input type="text" formControlName="mail_copies" class="form-control" id="mail_copies"
                    name="mail_copies" placeholder="Enter Email" autocomplete="off">
                    <span class="text-danger"
                    *ngIf="topicForm.controls['mail_copies'].value !=''  && topicForm.controls['mail_copies'].hasError('pattern')">Enter valid email
                    </span>
                </div>

                </form>
            </div>

            </div>
        
            <div class="modal-footer" *ngIf="!spinner">
            <div class="form-group topicBtnGroup">
                <ng-container *ngIf="disablepopup">
                <button class="btn btn-info cancelBtn" type="reset" data-bs-dismiss="modal" aria-label="Close"
                (click)="exitIconReset()">Cancel</button>
                <button [disabled]="topicForm.invalid" *ngIf="!showButton" class="btn btn-primary updateBtn" type="button"
                (click)="onSubmit()">Save</button>
                <button [disabled]="topicForm.invalid" *ngIf="showButton" class="btn btn-primary updateBtn" type="button"
                (click)="updateForm()">Update</button>
                </ng-container>
            </div>
            </div>
        
        </div>
        </div>
        </div>
    </div>
      <!-- stop word modal -->
    <div class="modal fade" id="stopWordModal" tabindex="-1" aria-labelledby="stopWordModalLabel" aria-hidden="true">
        <div class="modal-dialog">
        <div class="modal-content">
            <div class="modal-header">
            <h4 class="modal-title" id="stopWordModalLabel" *ngIf="stopWordShowInput === 'edit' ">Edit Stop Words</h4>
            <h4 class="modal-title" id="stopWordModalLabel" *ngIf="stopWordShowInput === 'create' ">Create Stop Words
            </h4>
            <i class="fa-solid fa-xmark exitIcon" data-bs-dismiss="modal" aria-label="Close" (click)="exitStopWord()"></i>
            </div>
            <div class="modal-body">
            <input *ngIf="stopWordShowInput === 'edit' " type="text" (ngModelChange)="changeInputStopWord()"
                class="form-control" [(ngModel)]="stopWords">
            <div class="form-group" *ngIf="stopWordShowInput === 'create' ">
                <tag-input class="form-control tagInput-form-control" placeholder="Keyword"
                secondaryPlaceholder="Enter Your Keyword" [addOnBlur]="true" [clearOnBlur]="true" [modelAsStrings]="true"
                theme="minimal" (ngModelChange)="changeInputStopWord()" [(ngModel)]="stopWords2" autocomplete="off"
                [addOnPaste]="true" [pasteSplitPattern]="splitPattern"></tag-input>
                <span class="modalNote">Note: To add multiple keywords, please Press Enter Key after
                typing
                each keyword</span>
            </div>
            </div>
            <div class="modal-footer">
            <button type="button" class="btn btn-primary cancelBtn" data-bs-dismiss="modal">Cancel</button>
            <button type="button" class="btn btn-primary updateBtn" data-bs-dismiss="modal" (click)="updateStopWordFun()"
                [disabled]="stopWordBtnShow"> <span *ngIf="stopWordShowInput === 'edit' ">Update</span> <span
                *ngIf="stopWordShowInput === 'create' ">Save</span> </button>
            </div>
        </div>
        </div>
    </div>
    <!-- stop word Delete Modal Window -->
    <div class="modal fade deleteModal" id="stopWordDeleteModal" tabindex="-1" aria-labelledby="stopWordDeleteModalLabel"
        aria-hidden="true">
        <div class="modal-dialog">
        <div class="modal-content">
            <div class="modal-header">
            <h4 class="modal-title" id="stopWordDeleteModalLabel">Delete Stop Word</h4>
            <i class="fa-solid fa-xmark exitIcon" data-bs-dismiss="modal" aria-label="Close"></i>
            </div>
            <div class="modal-body">
            Are you sure you want to delete?
            </div>
            <div class="modal-footer">
            <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">No</button>
            <button type="button" class="btn btn-danger" (click)="DeleteStopWordFun(getStopWordIndex)"
                data-bs-dismiss="modal">Yes</button>
            </div>
        </div>
        </div>
    </div>
    <!-- New Survey create modal -->
    <div class="modal fade newSurveyModalClass" id="newSurveyModal" data-bs-backdrop="static" data-bs-keyboard="false"
        tabindex="-1" aria-labelledby="newSurveyModalLabel" aria-hidden="true">
        <div class="modal-dialog modal-lg">
        <div class="modal-content">
            <div class="modal-header">
            <h4 class="modal-title" id="newSurveyModalLabel">Survey Details</h4>
            <i class="fa-solid fa-xmark exitIcon" data-bs-dismiss="modal" aria-label="Close"
                (click)="exitSurveyModal()"></i>
            </div>
            <div class="modal-body">
            <div class="container-fluid">
                <form [formGroup]="surveyForm">
                <div class="form-group">
                    <label for="topic" class="form-label mandatoryLabel">Survey Name
                    <i class="fa-solid fa-asterisk mandatoryIcon"></i></label>
                    <input type="text" class="form-control" formControlName="survey_name" id="survey_name"
                    name="survey_name" placeholder="Enter Your Survey Name">
                    <span class="text-danger"></span>
                </div>
                <div class="container-fluid">
                    <div class="row">
                    <div class="col-md-12">
                        <div formArrayName="question_answers">
                        <div *ngFor="let lessonForm of surveyFirstSection().controls; let i=index">
                            <div class="form-group form-array-form-group" [formGroupName]="i">
                            <div class="form-group d-flex">
                                <input type="text" class="form-control" formControlName="question" id="question"
                                name="question" placeholder="Enter your question">
                                <span class="text-danger"></span>
                                <i class="fa-solid fa-circle-xmark delete-input-exit-icon" (click)="deleteQuestionInput(i)"
                                tooltip="Delete" [options]="myOptions"></i>
                            </div>
                            <div formArrayName="answers">
                                <div *ngFor="let lessonForm2 of surveySecondSection(i).controls; let j=index">
                                <div class="form-group form-array-form-group answer-question-input-class"
                                    [formGroupName]="j">
                                    <div class="col-md-10">
                                    <div class="form-group qa-form-group d-flex">
                                        <input type="text" class="form-control" formControlName="answer" id="answer"
                                        name="answer" placeholder="Enter your answer">
                                        <i class="fa-solid fa-circle-xmark delete-input-exit-icon" *ngIf="j>0"
                                        (click)="deleteQuestionAnswerInputs(j, i)" tooltip="Delete"
                                        [options]="myOptions"></i>
                                    </div>
                                    </div>
                                    <div class="col-md-5">
                                    <div class="form-group qa-form-group">
                                        <input type="number" class="form-control" formControlName="score" id="score"
                                        name="score" placeholder="Enter your score"
                                        onkeydown="return event.keyCode !== 69">
                                    </div>
                                    </div>
                                </div>
                                </div>
                            </div>
                            <div class="col-md-12 newSurveyModalBtnClass">
                                <button class="btn btn-primary updateBtn add-more-choices-btn"
                                (click)="addSurveySecondSection(i)" #addSurveySecondSectionId><i
                                    class="fa fa-plus-circle addMoreIconModal" aria-hidden="true"></i> Add More
                                Choices</button>
                            </div>
                            </div>
                        </div>
                        </div>
                    </div>

                    </div>
                    <div class="col-md-12 newSurveyModalBtnClass">
                    <button class="btn btn-primary updateBtn" (click)="addSurveyFirstSection()"><i
                        class="fa fa-plus-circle addMoreIconModal" aria-hidden="true"></i> Add new question</button>
                    </div>
                </div>
                </form>
            </div>
            </div>
            <div class="modal-footer">
            <button type="button" class="btn btn-primary cancelBtn" (click)="exitSurveyModal()"
                data-bs-dismiss="modal">Cancel</button>
                <button type="button" *ngIf="!showButton" class="btn btn-primary updateBtn" data-bs-dismiss="modal">Create Survey</button>
                <button type="button" *ngIf="showButton" class="btn btn-primary updateBtn" data-bs-dismiss="modal">Update Survey</button>
            </div>
        </div>
        </div>
    </div>
</div>            